import axios from "axios";
import { API_BASE } from "../config.js";
import { getAccessToken } from "../auth/apiAuth.jsx";

const api = axios.create({
  baseURL: `${API_BASE}/api/data`,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const tk = getAccessToken && getAccessToken();
  if (tk) config.headers.Authorization = `Bearer ${tk}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      let msg =
        data?.error?.message ||
        (typeof data?.error === "string" ? data.error : null) ||
        data?.detail ||
        data?.message ||
        "Unknown error";
      const e = new Error(msg);
      e.status = status;
      e.details = data;
      if (status === 401) e.message = "Your session has expired. Please sign in again.";
      return Promise.reject(e);
    }
    return Promise.reject(error);
  }
);

/**
 * Get all NCR entries
 */
export async function getNCRs(options = {}) {
  const params = {};
  if (options.vendorId) params.vendorId = options.vendorId;
  if (options.status) params.status = options.status;
  if (options.severity) params.severity = options.severity;
  if (options.company) params.company = options.company;

  const response = await api.get("/quality/ncrs", { params });
  return response.data;
}

/**
 * Get NCR by ID
 */
export async function getNCRById(ncrId) {
  const response = await api.get(`/quality/ncrs/${ncrId}`);
  return response.data;
}

/**
 * Create a new NCR
 */
export async function createNCR(ncrData) {
  const response = await api.post("/quality/ncrs", ncrData);
  return response.data;
}

/**
 * Update an existing NCR
 */
export async function updateNCR(ncrId, ncrData) {
  const response = await api.patch(`/quality/ncrs/${ncrId}`, ncrData);
  return response.data;
}
